<template>
  <InputComponent v-bind="$attrs" class="field-choice">
    <ChoiceComponent v-model="comp" v-bind="$attrs" :values="items" />
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { ChoiceComponent } from 'vue-elder-choice'
import { ValueComp } from '../utils'

export default {
  props: {
    value: String,
    default: String,
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    comp: ValueComp(),
  },
  created() {
    let hasDefaultProp = 'default' in this.$options.propsData

    if (hasDefaultProp && this.value === undefined) this.comp = this.default
  },
  components: {
    InputComponent,
    ChoiceComponent,
  },
}
</script>

<style lang="scss">
.field-choice .elder-choices {
  gap: 0.5rem;
  flex-wrap: nowrap;
  margin: 0;

  .elder-choices__item {
    // margin: 0;

    &-label {
      padding: 1rem 0rem;
      min-width: 70px;
    }
  }
}
</style>
